import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { DICT } from "@/lib/i18n";

const KEY = "jm_journey_v1";
const EMPTY_FORM = { name: "", age: "", gender: "", address: "", phone: "", occupation: "", service_id: "", consent: false };
const INITIAL = { step: 0, lang: null, form: EMPTY_FORM, booking: null, sent: false };

const Ctx = createContext(null);

const load = () => {
  try {
    return { ...INITIAL, ...JSON.parse(sessionStorage.getItem(KEY) || "{}") };
  } catch {
    return INITIAL;
  }
};

export function AppProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [state, setState] = useState(load);

  useEffect(() => {
    sessionStorage.setItem(KEY, JSON.stringify(state));
    document.documentElement.lang = state.lang || "en";
  }, [state]);

  const reloadSettings = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)), []);
  useEffect(() => {
    reloadSettings();
  }, [reloadSettings]);

  const value = useMemo(() => {
    const lang = state.lang || "en";
    const t = (k) => DICT[lang][k] ?? DICT.en[k] ?? k;
    const pick = (obj, base) => (obj ? obj[`${base}_${lang}`] || obj[`${base}_en`] || "" : "");
    const update = (patch) => setState((s) => ({ ...s, ...patch }));
    const reset = () => setState((s) => ({ ...INITIAL, step: 1, lang: s.lang }));
    return { settings, reloadSettings, state, lang, t, pick, update, reset };
  }, [settings, reloadSettings, state]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
